
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import {
  Course,
  GetCourseResponse,
  UpsertCourseRequest,
  GetCourseTypeResponse,
  CourseType,
  TrainingTypeEnum,
  GetCourseRequest,
  UpsertCourseResponse,
} from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  name: "Course",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading, onRouterPush } = usePlugin();

    const courseTable = ref(null);
    const courses = ref<Course[]>([]);
    const course = ref<Course>({} as Course);
    const courseTypes = ref<CourseType[]>([]);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const existCourseId = ref(false);
    const duplicateCourseId = ref(false);

    const filteredCourse = computed(() => {
      if (!searchString.value) return courses.value;
      const fuse = new Fuse(courses.value, {
        keys: ["courseId", "description"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadCourses = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetCourseResponse>(
          "api/v1/services/course/get",
          {} as GetCourseRequest
        );
        courses.value = result.data.courses ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const loadCourseTypes = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetCourseTypeResponse>(
          "api/v1/services/courseType/get"
        );
        courseTypes.value = result.data.courseTypes ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewCourse = () => {
      course.value = {
        id: "",
        description: null,
        courseTypeId: null,
        courseType: null,
      };
      v$.value.$reset();
      showDialog.value = true;
      existCourseId.value = false;
    };

    const rules = {
      course: {
        description: { required: required },
        courseTypeId: { required: required },
      },
    };
    const v$ = useVuelidate(rules, { course }, { $autoDirty: true });

    const onSaveCourse = async () => {
      v$.value.$touch();
      if (v$.value.$error) return;

      setLoading(true);
      try {
        const result = await axios.post<UpsertCourseResponse>(
          "api/v1/services/course/upsert",
          {
            courses: [
              {
                id: "",
                description: course.value.description,
                courseTypeId: course.value.courseTypeId,
              },
            ],
          } as UpsertCourseRequest
        );
        await loadCourses();
        success("บันทึกข้อมูลสำเร็จแล้ว");

        if (result.data.course?.id) {
          onRouterPush({
            name: "editCourse",
            params: { id: result.data.course.id },
          });
        }
        showDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };

    const onHideDialog = () => {
      showDialog.value = false;

      duplicateCourseId.value = false;
    };

    const onEditCourse = (source: Course) => {
      onRouterPush({ name: "editCourse", params: { id: source.id } });
    };

    const onDeleteCourse = (source: Course) => {
      course.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteCourse = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/course/delete", {
          data: {
            courses: [course.value],
          } as UpsertCourseRequest,
        });
        await loadCourses();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
        popupDeleteDialog.value = false;
      } finally {
        setLoading(false);
      }
      // }
    };

    onMounted(async () => {
      loadCourseTypes();
      await loadCourses();
    });
    return {
      courseTable,
      course,
      courses,
      filteredCourse,
      showDialog,
      existCourseId,
      duplicateCourseId,
      popupDeleteDialog,
      searchString,
      onNewCourse,
      onEditCourse,
      onDeleteCourse,
      onSaveCourse,
      handleDeleteCourse,
      onHideDialog,
      courseTypes,
      TrainingTypeEnum,
      v$,
    };
  },
};
